export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#072600',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#35FA00',
  },
  {
    path: 'M150.784 329.216h151.552c112.64 0 161.28 81.92 161.28 182.784s-48.64 182.784-161.28 182.784H150.784z m64 313.344H277.76c100.352 0 121.856-57.344 121.856-130.56S378.112 381.44 277.76 381.44h-62.976zM488.192 430.08h61.952l51.712 197.632h1.024L652.544 430.08h58.88L759.04 627.712h1.024l53.76-197.632h59.392l-82.944 264.704h-59.904l-49.152-196.608h-1.024l-48.64 196.608h-61.44z',
    fill: '#35FA00',
  },
]
